import { gql } from '@apollo/client';

export const ABORT_EXECUTION = gql`
    mutation AbortExecution($input: AbortExecutionInput!) {
      abortExecution(input: $input) {
        id
      }
    }
  `;